import Decimal from "decimal.js";
import React from "react";

export const GSpreadComponent: React.FC<{ value: Decimal }> = (props) => <>{props.value.toFixed(0)}</>;
